import LazyLoad from 'vanilla-lazyload';
import Component from '../classes/Component';
import variables from '../variables';
import {isElement} from '../helpers/_utilities';
import {$dom} from '../helpers/dom';
import {$events} from "../helpers/events";

const {classNames, selectors, messages, customEventNames} = variables;
const {lazyLoaded, error} = classNames;
const {get, attr} = $dom;

const
    wrapperSelector = selectors.lazyWrapper,
    elementSelector = selectors.lazyElement,
    loaderSelector = '.js-lazy-loader',
    parentSelector = '.js-lazy-parent',
    errorAttr = 'data-error'
;

export default function(threshold = 0) {
    return new Component({
        name: 'lazyLoad',
        requiredTargets: elementSelector,
        onCreate() {
            this.lazyInstance = null;

            const removeLoader = (el) => {
                const wrapper = el.closest(wrapperSelector);
                el.removeAttribute(errorAttr);

                if (isElement(wrapper)) {
                    const preloader = get(loaderSelector, wrapper);
                    if (isElement(preloader)) {
                        preloader.remove();
                    }

                }
            };

            this.initInstance = () => {
                this.lazyInstance = new LazyLoad({
                    threshold,
                    elements_selector: elementSelector,
                    class_loaded: lazyLoaded,
                    class_error: error,
                    callback_loaded(el) {
                        removeLoader(el);

                        const parent = $dom.getParent(el, parentSelector);

                        parent && $dom.addClass(parent, lazyLoaded);

                        $events.emit(customEventNames.lazyImageLoaded, {}, el);
                    },
                    callback_error(el) {
                        removeLoader(el);
                        attr(el, errorAttr, messages.lazyError);
                        el.style.opacity = '1';
                    }
                });
            };

            this.update = () => {
                (this.lazyInstance && this.lazyInstance.initialized)
                    ? this.lazyInstance.update()
                    : this.initInstance();
            };

            this.resetImage = image => {
                image.setAttribute('data-src', '');
                image.setAttribute('src', '');
                $dom.removeClass(image, ['entered', 'is-loaded']);
                image.removeAttribute('data-ll-status');
            }

            return this.lazyInstance
        },
        onInit() {

            this.initInstance();
        },
        onDestroy() {
            if ($dom.exist(parentSelector))
                $dom.removeClass(parentSelector, lazyLoaded);

            if (this.lazyInstance instanceof LazyLoad) {
                this.lazyInstance.destroy();
                this.lazyInstance = null
            }
        }
    })
}

